import type { SVGProps } from 'react';
const DawnFlagBT = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BT_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-BT_svg__a)">
      <path fill="#FF5F38" d="M0 0h22v16H0z" />
      <path fill="#FFD951" fillRule="evenodd" d="M0 16 22 0H0z" clipRule="evenodd" />
    </g>
  </svg>
);
export default DawnFlagBT;
